import builder from './reducerBuilder'
import {
  ACTION_SHOW_LICENSE_LOADING,
  ACTION_SHOW_LICENSE_ERROR,
  ACTION_SHOW_LICENSE_LOADED,
  ACTION_UPDATE_LICENSE_LOADING,
  ACTION_UPDATE_LICENSE_ERROR,
  ACTION_UPDATE_LICENSE_LOADED,
  ACTION_CREATE_LICENSE_LOADING,
  ACTION_CREATE_LICENSE_ERROR,
  ACTION_CREATE_LICENSE_LOADED,
} from '../constants'

export default builder(
  [ACTION_SHOW_LICENSE_LOADING, ACTION_UPDATE_LICENSE_LOADING, ACTION_CREATE_LICENSE_LOADING],
  [ACTION_SHOW_LICENSE_LOADED, ACTION_UPDATE_LICENSE_LOADED, ACTION_CREATE_LICENSE_LOADED],
  [ACTION_SHOW_LICENSE_ERROR, ACTION_UPDATE_LICENSE_ERROR, ACTION_CREATE_LICENSE_ERROR])



// WEBPACK FOOTER //
// ./src/store/licenseReducer.js